'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _itemActions = require('photography-client-lib/dist/src/item/itemActions');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoveButton = function (_React$Component) {
  (0, _inherits3.default)(LoveButton, _React$Component);

  function LoveButton(props) {
    (0, _classCallCheck3.default)(this, LoveButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoveButton.__proto__ || (0, _getPrototypeOf2.default)(LoveButton)).call(this, props));

    _this.toggleLove = _this.toggleLove.bind(_this);
    _this.updateLoveCount = _this.updateLoveCount.bind(_this);

    _this.state = {
      isLoved: _itemActions.itemActions.isLoved(props.itemId),
      loveCount: _itemActions.itemActions.getLoveCount(props.itemId),
      animate: false
    };
    return _this;
  }

  (0, _createClass3.default)(LoveButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currIsLoved = _itemActions.itemActions.isLoved(nextProps.itemId);
      var currLoveCount = _itemActions.itemActions.getLoveCount(nextProps.itemId);
      if (nextProps.itemId !== this.props.itemId || this.state.isLoved !== currIsLoved || this.state.loveCount !== currLoveCount) {
        this.setState({
          isLoved: currIsLoved,
          loveCount: currLoveCount
        });
      }
    }
  }, {
    key: 'toggleLove',
    value: function toggleLove(e) {
      e.stopPropagation();
      e.preventDefault();
      var item = _lodash2.default.pick(this.props, ['layout', 'type', 'itemId', 'id', 'item', 'idx', 'hashtag']);
      (0, _assign2.default)(item, { type: 'image' });
      _itemActions.itemActions.postLoveActivity(item);
      _itemActions.itemActions.toggleLove(item.itemId, item.layout);
      this.setState({
        animate: !this.state.isLoved,
        isLoved: !this.state.isLoved
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _windowWrapper2.default.addEventListener('love_count_fetched', this.updateLoveCount);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _windowWrapper2.default.removeEventListener('love_count_fetched', this.updateLoveCount);
    }
  }, {
    key: 'containerClassName',
    value: function containerClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return 'fullscreen-social-love-container show-tooltip';
        default:
          return 'block-fullscreen gallery-item-social-love gallery-item-social-button show-tooltip';
      }
    }
  }, {
    key: 'buttonClasssName',
    value: function buttonClasssName() {
      var className = [];
      switch (this.props.layout) {
        case 'fullscreen':
          className.push('fullscreen-social-love');
          break;
        default:
          className.push('gallery-item-social-love');
          if (!_utils.utils.isStoreGallery()) {
            className.push('block-fullscreen');
          }
      }
      className.push(this.viewClassName());
      if (this.state.isLoved) {
        className.push('progallery-svg-font-icons-love_full pro-gallery-loved');
        className.push(' loved');
      } else {
        className.push('progallery-svg-font-icons-love_empty');
      }
      if (this.state.animate) {
        className.push('love-animation');
      }
      return className.join(' ');
    }
  }, {
    key: 'viewClassName',
    value: function viewClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return this.props.device === 'desktop' ? 'fullscreen-icon' : '';
        default:
          return '';
      }
    }
  }, {
    key: 'counterClassName',
    value: function counterClassName() {
      switch (this.props.layout) {
        case 'fullscreen':
          return 'fullscreen-social-love-count pro-fullscreen-shown ' + this.viewClassName();
        default:
          return 'block-fullscreen gallery-item-social-love-count ' + this.viewClassName();
      }
    }
  }, {
    key: 'createLoveCounter',
    value: function createLoveCounter() {
      var count = this.state.loveCount + (this.state.isLoved ? 1 : 0);
      return !!this.props.showCounter && count > 0 ? _react2.default.createElement(
        'i',
        {
          'data-hook': 'love-counter',
          className: this.counterClassName() },
        count
      ) : null;
    }
  }, {
    key: 'updateLoveCount',
    value: function updateLoveCount() {
      this.setState({
        loveCount: _itemActions.itemActions.getLoveCount(this.props.itemId)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var loveCounter = this.createLoveCounter();
      var clickAction = _utils.utils.getMobileEnabledClick(this.toggleLove);
      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({ 'data-hook': 'love-button',
          className: this.containerClassName()
        }, clickAction),
        _react2.default.createElement('button', {
          'data-hook': 'love-icon',
          className: this.buttonClasssName(),
          role: 'checkbox'
        }),
        loveCounter
      );
    }
  }]);
  return LoveButton;
}(_react2.default.Component);

exports.default = LoveButton;